import { createFileRoute } from '@tanstack/react-router'

import { PageContent } from '@/components/page-content'
import { PageHeaderSkeleton } from '@/components/skeleton/page-header-skeleton'
import { Skeleton } from '@/components/ui/skeleton'
import { jobsDescriptionQuery } from '@/queries/use-jobs-queries'

export const Route = createFileRoute('/_authenticated/jobs_/$jobId_/edit/description')({
  loader: ({ context: { queryClient }, params: { jobId } }) => queryClient.ensureQueryData(jobsDescriptionQuery(jobId)),
  pendingComponent: () => (
    <>
      <PageHeaderSkeleton title="Job description" />
      <PageContent>
        <Skeleton className="h-96 w-full" />
      </PageContent>
    </>
  ),
})
